import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraMetricStrip } from '@mono/ui-components/captains';
import { SpecraText } from '@mono/ui-components/ensigns';
import { money } from '../ratesView';
import { ParameterField } from './ParameterField';
export function TravelClinEditor({ clinPricing: clin, onChange }) {
    const travel = clin.metadata.travelConfig;
    if (!travel) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ _jsx(SpecraMetricStrip, {
                density: "compact",
                metrics: [
                    {
                        id: 'nte',
                        label: 'Government NTE',
                        value: money(String(travel.governmentNTE)),
                        tone: 'neutral'
                    }
                ]
            }),
            /*#__PURE__*/ _jsx(SpecraText, {
                children: "Fixed handling rate (fraction)"
            }),
            /*#__PURE__*/ _jsx(SpecraText, {
                children: "Handling rate is saved but is not included in pricing totals."
            }),
            /*#__PURE__*/ _jsx(ParameterField, {
                label: "Fixed handling rate % (fraction)",
                param: travel.handlingRatePct,
                editable: true,
                onChange: (value)=>onChange({
                        ...clin,
                        metadata: {
                            ...clin.metadata,
                            travelConfig: {
                                ...travel,
                                handlingRatePct: {
                                    ...travel.handlingRatePct,
                                    value
                                }
                            }
                        }
                    })
            })
        ]
    });
}
